import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCockade = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16 18.667C20.4183 18.667 24 15.0853 24 10.667C24 6.24871 20.4183 2.66699 16 2.66699C11.5817 2.66699 8 6.24871 8 10.667C8 15.0853 11.5817 18.667 16 18.667Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M20.6359 17.1865L22.6666 29.3332L15.9999 25.3332L9.33325 29.3332L11.3639 17.1865",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgCockade);
export default ForwardRef;
